import { Component, EventEmitter, Output } from '@angular/core';

export interface ForgotPasswordPayload {
  step: 'request' | 'confirm';
  email: string;
  code?: string;
  newPassword?: string;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
}

@Component({
  selector: 'app-forgot-password-card',
  standalone: false,
  templateUrl: './forgot-password-card.component.html',
  styleUrls: ['./forgot-password-card.component.css'],
})
export class ForgotPasswordCardComponent {
  @Output() forgotPasswordSubmit = new EventEmitter<ForgotPasswordPayload>();
  @Output() backToLogin          = new EventEmitter<void>();

  // step 1: enter email
  // step 2: enter code + new password
  step: 'request' | 'confirm' = 'request';

  email           = '';
  code            = '';
  newPassword     = '';
  confirmPassword = '';
  showNew         = false;
  showConfirm     = false;
  loading         = false;
  errorMessage    = '';
  successMessage  = '';

  get emailValid(): boolean { return /\S+@\S+\.\S+/.test(this.email); }
  get passwordsMatch(): boolean { return this.newPassword === this.confirmPassword; }
  get newPasswordValid(): boolean { return this.newPassword.length >= 8; }
  get confirmFormValid(): boolean {
    return this.code.trim().length > 0 && this.newPasswordValid && this.passwordsMatch;
  }

  onRequestCode(): void {
    if (!this.emailValid || this.loading) return;
    this.loading      = true;
    this.errorMessage = '';
    this.forgotPasswordSubmit.emit({
      step:  'request',
      email: this.email,
      onSuccess: (msg) => {
        this.successMessage = msg;
        this.loading        = false;
        this.step           = 'confirm';
      },
      onError: (msg) => { this.errorMessage = msg; this.loading = false; },
    });
  }

  onConfirmCode(): void {
    if (!this.confirmFormValid || this.loading) return;
    this.loading      = true;
    this.errorMessage = '';
    this.forgotPasswordSubmit.emit({
      step:        'confirm',
      email:       this.email,
      code:        this.code,
      newPassword: this.newPassword,
      onSuccess: (msg) => { this.successMessage = msg; this.loading = false; },
      onError:   (msg) => { this.errorMessage   = msg; this.loading = false; },
    });
  }

  resendCode(): void {
    this.step           = 'request';
    this.errorMessage   = '';
    this.successMessage = '';
    this.code           = '';
    this.newPassword    = '';
    this.confirmPassword= '';
  }

  onBack(): void { this.backToLogin.emit(); }
}